import { useEffect, useState } from "react";

export type Theme = "slate" | "light";
const KEY = "zenith.theme";

/** Two themes on tokens (ZENITH.md §18). The choice sticks in this browser;
 * with no choice, prefers-color-scheme decides via CSS. */
export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(() => {
    try { const v = localStorage.getItem(KEY); if (v === "slate" || v === "light") return v; } catch { /* ignore */ }
    return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "slate";
  });
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
  }, [theme]);
  return [theme, setTheme];
}
